import { FC } from 'react';
import { SignupConsultationBailout } from './SignupConsultationBailout';
import { useTranslation } from 'react-i18next';
import { CalendarDots, SealQuestion } from '@phosphor-icons/react';

type Props = {
  onBailoutToConsultDueToAvailability: () => void;
  onBailoutToConsultDueToQuestion: () => void;
};

const Component: FC<Props> = ({ onBailoutToConsultDueToAvailability, onBailoutToConsultDueToQuestion }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap flex-col desktop:flex-row desktop:flex-nowrap gap-e24">
      <SignupConsultationBailout
        key="availability-bailout"
        heading={t('directSignup.schedule.switchToConsult.bailout_1.heading')}
        copy={t('directSignup.schedule.switchToConsult.bailout_1.copy')}
        cta={t('directSignup.schedule.switchToConsult.bailout_1.CTA')}
        icon={<CalendarDots weight="fill" size={20} />}
        onBailout={onBailoutToConsultDueToAvailability}
        cardTestId="availability-bailout"
      />
      <SignupConsultationBailout
        key="question-bailout"
        heading={t('directSignup.schedule.switchToConsult.bailout_2.heading')}
        copy={t('directSignup.schedule.switchToConsult.bailout_2.copy')}
        cta={t('directSignup.schedule.switchToConsult.bailout_2.CTA')}
        icon={<SealQuestion weight="fill" size={20} />}
        onBailout={onBailoutToConsultDueToQuestion}
        cardTestId="question-bailout"
      />
    </div>
  );
};

export const SignupConsultationDualBailout = Component;
